export default __webpack_public_path__ + "static/media/mig_rate.77852f32.csv";